module.exports = __webpack_public_path__ + "img/ivydad-logo.11de8c93.png";